import { render } from "./HowToSuitView.vue?vue&type=template&id=60198f56&scoped=true"
import script from "./HowToSuitView.vue?vue&type=script&lang=js"
export * from "./HowToSuitView.vue?vue&type=script&lang=js"

import "./HowToSuitView.vue?vue&type=style&index=0&id=60198f56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60198f56"]])

export default __exports__